import { Component, OnInit, ViewChild } from '@angular/core';
import { E5coreUiDatagridBase } from './e5core-ui-datagrid-base';
import { MaterialTableDataSource } from './material-table-data-source';
import { DataSourceQuery } from '../../../datasource/data-source-query';
import { PageEvent, MatSort, MatPaginator } from '@angular/material';
import { ColumnDef } from '../../e5core-ui-search-results/component/e5core-ui-search-results-material.component';
import { DataSourceColumn } from '../../../datasource/data-source-column';

@Component({
    selector: 'e5core-ui-datagrid-material',
    templateUrl: './e5core-ui-datagrid-material.component.html',
    styleUrls: ['./e5core-ui-datagrid-material.component.css']
})
export class E5coreUiDatagridMaterialComponent extends E5coreUiDatagridBase implements OnInit {

    tableDataSource: MaterialTableDataSource;
    isEmpty = false;

    length = 0;
    pageSize = 10;
    pageSizeOptions: number[];
    findClassId: number;
    loading = true;
    delayedQuery: DataSourceQuery;
    headings: DataSourceColumn[];

    // MatPaginator Output
    pageEvent: PageEvent;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor() {
        super();
    }

    ngOnInit() {
        this.pageSizeOptions = (this.pagesizes && this.pagesizes.length > 0) ? this.pagesizes : [5, 10, 25, 50];
        // this.tableDataSource = new SearchMatTableDataSource(this.datasource); // this.history.getHistory(id, 0, 10) ;

        this.tableDataSource = new MaterialTableDataSource(this.datasource); // this.history.getHistory(id, 0, 10) ;
        this.tableDataSource.sort = this.sort;
        this.tableDataSource.paginator = this.paginator;
        this.tableDataSource.loadingEvents.subscribe(
            loading => {
                this.loading = loading ;
            }
        ) ;
        // Load the columns
        this.loading = true;
        this.datasource.columns().subscribe(
            dsColumns => {
                this.headings = dsColumns;
                this.loading = false;
                if (this.delayedQuery || this.autoSearch) {
                    this.search(this.delayedQuery);
                }
            },
            error => { },
            () => {
                this.loading = false;
            }
        ) ;
    }

    setPageSizeOptions(setPageSizeOptionsInput: string) {
        this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }

    /**
     * Return the list of columns available in the table.
     */
    columns(): ColumnDef[] {
        if (this.headings) {
            const cols = (this.headings
                .filter(f => f.code !== 'Id') // Id is added at the beginning
                .map<ColumnDef>(f => <ColumnDef>{
                    label: f.label,
                    name: f.code,
                    type: f.type,
                    status: f.status
                }));
            return (cols);
        }
        return [];
    }

    /**
     * Return the list of column names that will be displayed in the table.
     */
    displayedColumns(): string[] {
        const cols = this.columns()
            .filter(f => f.status > 1) // Selected only
            .map<string>(c => c.name);
        cols.unshift('Id');
        return (cols);
    }

    search(query: DataSourceQuery) {
        if (this.tableDataSource) {
            this.tableDataSource.search(query);
        } else {
            this.delayedQuery = query;
        }
    }

    reset() {
        this.tableDataSource.reset();
    }

    refresh() {
        this.tableDataSource.refresh();
    }

}
